export default __webpack_public_path__ + "static/media/progress-indicator-small-na.f3988c34.svg";